import { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import CardSection from "../Components/CardSection";
import Quote from "../Components/Quote";
import LongDistanceMovingTips from "./LongDistanceMovingTips";
import { url, header } from "../Constent/Constant";
import BlogsCard from "../Components/BlogsCard";
import GetQuoteForm from "../Components/GetQuoteForm";
import TypeOfMoving from "../Components/TypeOfMoving";

function Blogs() {
  const [BlogData, setBlogData] = useState('')
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if (LoggedIn !== 'true') {
    history.push('/')
  }
  useEffect(() => {
    UpdateData()
  }, [])

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: 'POST',
      body: JSON.stringify({
        name: "Blogs"
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setBlogData(data.doc)
      })
  }

  const UpdateText = (DataObject) => {
    console.log(DataObject)
    if (DataObject !== '') {
      fetch(`${url}/page/updatedata`, {
        method: 'POST',
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            UpdateData()
          }
        })
    }
  }

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append('image', DataObject.image)
    Imagedata.append('id', DataObject.id)

    fetch(`${url}/page/updateimage`, {
      method: 'POST',
      body: Imagedata
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.message === 'Success') {
          UpdateData()
        }
      })
  }

  return (
    <Layout>
      {/* {BlogData && <Header
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={{
          imgId: BlogData.section1image1._id,
          headingId: BlogData.section1heading1._id
        }}
        Image={BlogData.section1image1.image}
      />} */}

      {BlogData && <TypeOfMoving
        UpdateText={UpdateText}
        GetData={BlogData} />}

      {/* {BlogData && <BlogsCard
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={BlogData} />} */}

      {BlogData !== '' &&
        <div className='Blog-Service'>
          <Quote
            UpdateText={UpdateText}
            UpdateImage={UpdateImage}
            SubHeading={BlogData.section4subheading1.content}
            SectionData={{
              SubHeadingId: BlogData.section4subheading1._id,
              image: BlogData.section4image1.image,
              imageId: BlogData.section4image1._id,
              heading: BlogData.section4heading1.content,
              headingId: BlogData.section4heading1._id,
              para1: BlogData.section4paragraph1.content,
              para1Id: BlogData.section4paragraph1._id,
              buttonClass: 'Secondary-btn Button blogs-Btn'
            }} />
        </div>}

      {BlogData && <CardSection
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        Heading={BlogData.section5heading1.content}
        HeadingId={BlogData.section5heading1._id}
        CardData={{
          card1: {
            img: BlogData.section5image1.image,
            imgId: BlogData.section5image1._id,
            heading: BlogData.section5heading2.content,
            headingId: BlogData.section5heading2._id,
            para: BlogData.section5paragraph1.content,
            paraId: BlogData.section5paragraph1._id,
          },
          card2: {
            img: BlogData.section5image2.image,
            imgId: BlogData.section5image2._id,
            heading: BlogData.section5heading3.content,
            headingId: BlogData.section5heading3._id,
            para: BlogData.section5paragraph2.content,
            paraId: BlogData.section5paragraph2._id,
          },
          card3: {
            img: BlogData.section5image3.image,
            imgId: BlogData.section5image3._id,
            heading: BlogData.section5heading4.content,
            headingId: BlogData.section5heading4._id,
            para: BlogData.section5paragraph3.content,
            paraId: BlogData.section5paragraph3._id,
          }
        }} />
      }
     {BlogData && <LongDistanceMovingTips />}
      {
        BlogData && <GetQuoteForm UpdateImage={UpdateImage}
          imageID={BlogData.image._id} image={BlogData.image.image} />
      }
    </Layout>
  );
}

export default Blogs;
